if (!customElements.get('product-wish-list')) {

  // noinspection JSUnusedGlobalSymbols
  class ProductWishList extends HTMLElement {
    constructor () {
      super();

      const main = document.querySelector("main");
      if (main) {
        main.classList.add("loadcomplete");
      }

      this.content = this.querySelector('[data-js="content"]');
    }

    /**
     * Invoked each time one of the custom element's attributes is added, removed, or changed
     */
    attributeChangedCallback () {
      this.rendered = false;
      this.html = undefined;
      this.startLoading();
      this.init();
    }

    /**
     * Runs when element is created
     */
    connectedCallback () {
      if (!this.rendered) {
        this.init();
      }
    }

    /**
     * Initialize state data
     */
    setupData () {
      this.data = {
        wishListBtnSelector: 'wish-list-button',
        searchUrl: window.wishListRouteSearchUrl,
        message: {
          emptyItem: this.getAttribute('messageEmptyItem') || 'No items',
          error: this.getAttribute('messageError') || "Can't get data",
        }
      };
    }

    /**
     * Check Login
     */
    checkLogin = async () => {
      const customer = await getCustomer();
    
      if (!customer) {
        return;
      }
    };

    /**
     * Initialize data
     */
    init () {
      this.checkLogin();
      this.setupData();
      this.loaded((swat) => {
        this.swat = swat;
        this.render();
      });

      this.rendered = true;
    }

    /**
     * When the user click the wishlist button
     */
    addEventForWishListButton () {
      let wishListButtonSelector = this.data.wishListBtnSelector;
      let wishListButtons = this.querySelectorAll(wishListButtonSelector);

      if (wishListButtons.length) {
        wishListButtons.forEach((button) => {

          // Called when wishlist status change event in `assets/wish-list-button.js`
          button.addEventListener('changeStatus', () => {
            let wishListButtonElements = this.querySelectorAll(wishListButtonSelector);

            if (wishListButtonElements.length > 1) {
              button.parentElement.remove();
            } else {
              this.renderEmpty();
            }
          });
        });
      }
    }

    /**
     * Initialize connect to App
     * @param callback
     */
    loaded (callback) {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }

      window.SwymCallbacks.push((swat) => {
        callback(swat);
      });
    }

    /**
     * @param callback
     */
    afterRender (callback) {
      setTimeout(() => {
        callback();
      }, 600);

      this.content.parentElement.classList.remove('default');
    }

    /**
     * Based on file `search.wishlist.liquid` to get HTML json
     *
     * @param list
     * @returns {Promise<any>}
     */
    async renderProductHTML (list) {
      try {
        let variantIds = list.map((item) => {
          return item.epi;
        });

        let productIds = list.map((item) => {
          return `(id:"${item.empi}")`;
        });

        let queryString = Array.from(new Set(productIds)).join(' OR ');

        if (list.length > 0) {
          return await fetch(this.data.searchUrl + '&variant_ids=' + variantIds.join('-') + '&type=product&q=' + queryString, {
            credentials: 'same-origin',
            method: 'GET'
          }).then(response => response.json()).then(data => {
            if (data.items && data.items.length) {
              let html = '';
              let itemData = data.items.filter(item => item)

              list.forEach((item) => {
                let productCard = itemData.find(productItem => productItem.id === item.epi);
                //商品詳細画面で追加した場合
                //商品詳細画面で追加したセール商品はproductCardがundefinedになるので条件に追加してスキップ
                if(item.cprops && item.cprops.isProductDetail && productCard !== undefined){
                  productCard.html = productCard.html.replace('c-card ', 'c-card is-added-product_page ')
                }
                if (productCard) {
                  html += productCard.html;
                }
              });

              return {
                listHtml: html,
                total: data.total
              };
            } else {
              this.renderEmpty();
            }
          });
        } else {
          this.renderEmpty();
        }
      } catch (e) {
        console.log(e);
        this.renderError();
      }
    }

    /**
     * Show Empty Message
     */
    renderEmpty () {
      this.content.parentElement.classList.add('default');
      this.content.innerHTML = `<span>${this.data.message.emptyItem}</span>`;
    }

    /**
     * Show Error Message
     */
    renderError () {
      this.content.parentElement.classList.add('default');
      this.content.innerHTML = `<span>${this.data.message.error}</span>`;
    }

    /**
     * Render HTML
     */
    render () {
      this.swat.fetch((list) => {

        // Invoked at most once after being added
        if (typeof this.html === "undefined") {
          this.renderProductHTML(list).then((data) => {
            if (!data || !data.listHtml) return;

            this.html = data.listHtml;
            this.content.innerHTML = data.listHtml;

            this.afterRender(() => {
              this.addEventForWishListButton();
              this.endLoading();
            });
          });
        }
      });
    }

    startLoading () {
    }

    endLoading () {
    }
  }
  customElements.define('product-wish-list', ProductWishList);
}
